import { useTranslation } from "react-i18next";

export default function Error() {
  const {t} = useTranslation()
  
  return <div>{t('page.error.title')}</div>;
}
